/**
*  Copyright (c) 2020 Micro Focus Software Inc.  All Rights Reserved.
*
* THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
* AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
* WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
* TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
* AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
* INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
* PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
* CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
* OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
* ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
* THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
*/

import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { LoginService } from './login.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Router, ActivatedRoute } from '@angular/router';
import { PasswordResetResponse } from './model/passwordresetresponse';
import { DomainResponse } from './model/domainresponse';
import { LoginResponse, OauthResponse, TokenResponse } from './model/loginresponse';
import { SpinnerService } from '../shared/spinner/spinner.service';
import { CustomizationEnabledResponse } from './model/customizationenabledresponse';
import { CustomerPreferenceService } from '../customer/preference/customerpreference.service';
import { CustomerPreferenceUtil } from '../customer/preference/customerpreferenceutil';
import { ZSDTranslateService } from '../common/zsd-translate.service';
import { ZsdLoggingService } from '../common/zsd-logging.service';
import { DomSanitizer } from '@angular/platform-browser';
import { UIMessageService } from '../customer/feature/shared/services/uimessages.service';
import { UIMessagesResponse } from '../customer/feature/shared/model/uimessagesresponse';
declare var $: any;

@Component({
  selector: 'zsd-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'
  ],
  encapsulation: ViewEncapsulation.None
})

export class LoginComponent implements OnInit {

  loginErrorMessage = '';
  domainErrorMessage = '';

  loginForm: FormGroup;
  usernameFocus: boolean;
  passwordFocus: boolean;
  customizeEnabled: boolean;
  imageLoaded = false;
  loginBannerSrc;

  oauth_user = false;

  authurltoredirect: string;
  providerDisplayName: string;

  sspr: PasswordResetResponse = new PasswordResetResponse();
  ldapDomains: DomainResponse = new DomainResponse();
  uiMessageListResults: Array<UIMessagesResponse> = [];
  loginLegend = '';

  isLoginLoading = false;
  returnUrl: string;
  redirectLandingUri: string;

  constructor(public loginService: LoginService, public formBuilder: FormBuilder,
    public spinnerService: SpinnerService, public router: Router, public route: ActivatedRoute,
    public customerPreferenceService: CustomerPreferenceService,
    public uiMessageService: UIMessageService,
    public _DomSanitizer: DomSanitizer,
    public customerPreference: CustomerPreferenceUtil, public zsdTranslateService: ZSDTranslateService,
    public loggerService: ZsdLoggingService) {
    this.loginForm = formBuilder.group({
      username: [],
      password: [],
      domain: []
    });
  }


  checkOauthUser(){
    this.oauth_user = false;
    const userName = this.loginForm.controls.username.value;
    this.redirectLandingUri = window.location.origin + '/servicedesk/login';
    if(userName){
    $('#zsd_login_error_message').css('display', 'none');
    this.loginService.oauthUserDetails(userName, this.redirectLandingUri).subscribe(
      (oauthresponse: OauthResponse) => {
        this.oauth_user = true;
        this.authurltoredirect = oauthresponse.authUrl;
        this.providerDisplayName = oauthresponse.providerName;
      });  
    }
  }
    ngOnInit() {

    this.oauthLogin();
    
    $('#gotoTop').css('visibility', 'hidden');
    this.route.queryParams.subscribe(params => {
      const username = params['username'];
      this.loginForm.get('username').setValue(username);
    });

    this.loginService.getDomains().subscribe(
      (domainResponse: DomainResponse) => {
        this.ldapDomains = domainResponse;

        if (domainResponse.resultCount > 1) {
          this.fillFormFields('', '', domainResponse.results[0].ldapSourceId);
        }
      },
      err => {
        // TODO: process error and display error message to user in UI and log the same
        const error = err.error;
        this.loggerService.log('Error occured while getting self service link' + error, 'LoginComponent');
        if (error.code !== null && error.code !== undefined) {
          this.domainErrorMessage = this.zsdTranslateService.getTranslatedString('Login', error.code);
        } else {
          this.domainErrorMessage = this.zsdTranslateService.getTranslatedString('Login', 'domainClientErrorMessage');
        }
        this.loginErrorMessage = this.loginErrorMessage.concat(this.domainErrorMessage);
      }
    );

    this.loginService.getPasswordResetLink().subscribe(
      (ssprResponse: PasswordResetResponse) => {
        this.sspr = ssprResponse;
      },
      err => {
        this.loggerService.log('Error occured while getting self service link' + err.error, 'LoginComponent');
      }
    );
    this.loginService.isCustomizeEnabled().subscribe(
      (response: CustomizationEnabledResponse) => {
        this.customizeEnabled = response.customizeEnabled;
        if (this.customizeEnabled) {
          this.loginBannerSrc = '../LiveTime/images/banners/custom/custom_eupLogin.png';
        } else {
          this.loginBannerSrc = ' img/zenworks_servicedesk_header.png';
         }
         this.imageLoaded = true;
      },
      err => {
        this.loggerService.log('Error occured while getting customization detail.' + err.error, 'LoginComponent');
      });

      this.uiMessageService.getUIMessagesList().subscribe(
        (uimessages: UIMessagesResponse[]) => {
            this.uiMessageListResults = uimessages;
            for (let i = 0; i < this.uiMessageListResults.length; i++) {
                if (this.uiMessageListResults[i].name === 'LoginLegend') {
                    this.loginLegend = this.uiMessageListResults[i].content;
                }
            }
        },
        err => console.log(err)
    );
  }


  login() {
    if(this.oauth_user){
      window.location.href = this.authurltoredirect;
    } else {
      this.loginErrorMessage = null;
      this.loginForm.get('username').setValidators([Validators.required]);
      this.loginForm.get('username').updateValueAndValidity();
      this.loginForm.get('password').setValidators([Validators.required]);
      this.loginForm.get('password').updateValueAndValidity();
      if (this.ldapDomains.resultCount > 0) {
        this.loginForm.get('domain').setValidators([Validators.required]);
        this.loginForm.get('domain').updateValueAndValidity();
      }
      if (this.loginForm.valid) {
        this.isLoginLoading = true;
        this.spinnerService.smallShow();
        const username = this.loginForm.controls.username.value;
        const password = this.loginForm.controls.password.value;
        const domain = this.loginForm.controls.domain.value;
        this.loginService.authenticate(username, password, domain).subscribe(
          (loginResponse: LoginResponse) => {
            const jwtHelper = new JwtHelperService();
            let tokenRespone = new TokenResponse();
            tokenRespone = jwtHelper.decodeToken(loginResponse.token);
            if (tokenRespone.scopes.indexOf('Customer') === -1) {
              this.isLoginLoading = false;
              this.spinnerService.smallHide();
              this.fillFormFields(username, '', domain);
              this.loginErrorMessage = this.zsdTranslateService.getTranslatedString('Login', 'login_unauthorize');
            } else {
              this.fillFormFields(username, password, domain);
              if (loginResponse.success) {
                $('#gotoTop').css('visibility', 'visible');
                this.isLoginLoading = false;
                this.spinnerService.smallHide();
                localStorage.setItem('token', loginResponse.token);
                localStorage.setItem('refreshToken', loginResponse.refreshToken);
  
                /* Based on the customer preferences setting enabled tab in 'cusPref' varibable in local stoarge
                and routing to the enabled tab on successful login*/
                this.customerPreference.setPrivilgesBasedPreferences().then(() => {
                // let privilegeEnabledTab: Array<string> = JSON.parse(localStorage.getItem('cusPref'));
              //   this.router.navigate([privilegeEnabledTab[JSON.parse(localStorage.getItem('defaultTab'))]]);
                  this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
                  this.router.navigateByUrl('/' + this.returnUrl);
                  // this.router.navigate([this.returnUrl])
                  // this.router.navigate(['/home']);
                });
  
              } else {
                // TODO Login Failure handling code if response code is 200 from post call
                // If response code is 400 handle login failue in error section
              }
            }
          },
          err => {
            this.isLoginLoading = false;
            this.spinnerService.smallHide();
            const error = err.error;
            this.fillFormFields(username, '', domain);
            this.loggerService.log('Error occured while login.' + err.error, 'LoginComponent');
            if (error.code !== null && error.code !== undefined) {
              this.loginErrorMessage = this.zsdTranslateService.getTranslatedString('Login', error.code);
            } else {
              this.loginErrorMessage = this.zsdTranslateService.getTranslatedString('Login', 'loginClientErrorMessage');
            }
          }
        );
      } else {
        this.isLoginLoading = false;
        this.spinnerService.smallHide();
      }
    }
  
  }

  fillFormFields(username: string, password: string, domain: number) {
    this.loginForm.reset({
      'username': username,
      'password': password,
      'domain': domain
    });
    this.loginForm.get('username').clearValidators();
    this.loginForm.get('password').clearValidators();
    this.loginForm.get('domain').clearValidators();
    this.loginForm.get('username').updateValueAndValidity();
    this.loginForm.get('password').updateValueAndValidity();
    this.loginForm.get('domain').updateValueAndValidity();

  }

  public isSSPRActive(): boolean {
    return (this.sspr.ssprLink != null && this.sspr.ssprLink.length > 0);
  }

  trackByldap(index ) {
    return index;
  }


  oauthLogin(){
    let state;
    let authCode;
    // To Fetch the values from the Params from Redirect URL
    // To pass the Values to the Next Service 
    this.route.queryParams.subscribe(params => {
        state = params['state'];
        authCode = params['code'];
    });
    if(state && authCode) {
    this.oauth_user = false;
    this.isLoginLoading = true;
    this.spinnerService.smallShow();  
    this.redirectLandingUri = window.location.origin + '/servicedesk/login';
    // call service and pass the values
    this.loginService.oauthLogin(state, authCode, this.redirectLandingUri).subscribe(
      (loginResponse: LoginResponse) => {
        this.isLoginLoading = false;
        this.spinnerService.smallHide();
        const jwtHelper = new JwtHelperService();
        let tokenRespone = new TokenResponse();
        tokenRespone = jwtHelper.decodeToken(loginResponse.token);
        if (tokenRespone.scopes.indexOf('Customer') === -1) {
          // this.fillFormFields(username, '', domain);
          this.loginErrorMessage = this.zsdTranslateService.getTranslatedString('Login', 'login_unauthorize');
        } else {
          // this.fillFormFields(username, password, domain);
          if (loginResponse.success) {
            $('#gotoTop').css('visibility', 'visible');
          
            localStorage.setItem('token', loginResponse.token);
            localStorage.setItem('refreshToken', loginResponse.refreshToken);

            /* Based on the customer preferences setting enabled tab in 'cusPref' varibable in local stoarge
            and routing to the enabled tab on successful login*/
            this.customerPreference.setPrivilgesBasedPreferences().then(() => {
            // let privilegeEnabledTab: Array<string> = JSON.parse(localStorage.getItem('cusPref'));
          //   this.router.navigate([privilegeEnabledTab[JSON.parse(localStorage.getItem('defaultTab'))]]);
              this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
              this.router.navigateByUrl('/' + this.returnUrl);
              // this.router.navigate([this.returnUrl])
              // this.router.navigate(['/home']);
            });

          } else {
            // TODO Login Failure handling code if response code is 200 from post call
            // If response code is 400 handle login failue in error section
          }
        }
      },
      err => {
        this.isLoginLoading = false;
        this.spinnerService.smallHide();
        const error = err.error;
        // this.fillFormFields(username, '', domain);
        this.loggerService.log('Error occured while login.' + err.error, 'LoginComponent');
        if (error.code !== null && error.code !== undefined) {
          this.loginErrorMessage = this.zsdTranslateService.getTranslatedString('Login', error.code);
        } else {
          this.loginErrorMessage = this.zsdTranslateService.getTranslatedString('Login', 'loginClientErrorMessage');
        }
      }
    );
  }
}

}
